export default {

    customFields:[
        {
            workspaceIds: ["h3G9giuGoC8iaD6YWgrN", "DbpsiFfSD0WnWpy4fa6x"],
            info:{

            },
            fields: [
                {
                    "name": "graduationCourse",
                    "type": "text",
                    "placeholder": "curso de graduação",
                    values: [
                        "Administração",
                        "Agronomia",
                        "Arqueologia",
                        "Arquitetura e Urbanismo",
                        "Artes Visuais",
                        "Biblioteconomia",
                        "Biomedicina",
                        "Ciência da Computação",
                        "Ciências Biológicas",
                        "Ciências Atuariais",
                        "Ciências Contábeis",
                        "Ciências Econômicas",
                        "Ciências Naturais",
                        "Ciências Sociais",
                        "Cinema e Audiovisual",
                        "Dança",
                        "Design",
                        "Direito",
                        "Educação Física",
                        "Educação Física",
                        "Enfermagem",
                        "Engenharia Aeronáutica",
                        "Engenharia Agrícola",
                        "Engenharia Ambiental e Sanitária",
                        "Engenharia Cartográfica e de Agrimensura",
                        "Engenharia Civil",
                        "Engenharia de Alimentos",
                        "Engenharia de Bioprocessos",
                        "Engenharia de Computação",
                        "Engenharia de Controle e Automação",
                        "Engenharia de Fortificação e Construção  (oferta exclusiva das Forças Armadas)",
                        "Engenharia de Materiais",
                        "Engenharia de Minas",
                        "Engenharia de Pesca",
                        "Engenharia de Petróleo",
                        "Engenharia de Produção",
                        "Engenharia de Telecomunicações",
                        "Engenharia Elétrica",
                        "Engenharia Eletrônica",
                        "Engenharia Florestal",
                        "Engenharia Mecânica",
                        "Engenharia Mecânica de Armamentos  (oferta exclusiva das Forças Armadas)",
                        "Engenharia Mecânica de Veículos Militares  (oferta exclusiva das Forças Armadas)",
                        "Engenharia Metalúrgica",
                        "Engenharia Naval",
                        "Engenharia Química",
                        "Engenharia Têxtil",
                        "Estatística",
                        "Farmácia",
                        "Filosofia",
                        "Filosofia",
                        "Física",
                        "Fisioterapia",
                        "Fonoaudiologia",
                        "Geografia",
                        "Geologia",
                        "História",
                        "História",
                        "Informática",
                        "Jornalismo",
                        "Letras - Língua Estrangeira",
                        "Letras - Língua Portuguesa",
                        "Matemática",
                        "Medicina",
                        "Medicina Veterinária",
                        "Meteorologia",
                        "Museologia",
                        "Música",
                        "Nutrição",
                        "Odontologia",
                        "Pedagogia",
                        "Psicologia",
                        "Publicidade e Propaganda",
                        "Química",
                        "Radio",
                        "TV",
                        "Internet (Comunicação Audiovisual e Multimídia) ",
                        "Relações Internacionais",
                        "Relações Públicas",
                        "Secretariado Executivo",
                        "Serviço Social",
                        "Sistemas da Informação",
                        "Teatro",
                        "Teologia",
                        "Terapia Ocupacional",
                        "Turismo",
                        "Zootecnia",
                        "Administração Pública",
                        "Agrimensura",
                        "Agroecologia",
                        "Agronegócios e Agropecuária",
                        "Alimentos",
                        "Análise e Desenvolvimento de Sistemas",
                        "Animação",
                        "Aquicultura",
                        "Artes",
                        "Astronomia",
                        "Automação Industrial",
                        "Banco de Dados",
                        "Biocombustíveis",
                        "Biossistemas",
                        "Biotecnologia",
                        "Biotecnologia e Bioquímica",
                        "Ciência da Terra",
                        "Ciência e Economia",
                        "Ciência e Tecnologia",
                        "Ciência e Tecnologia das Águas/do Mar",
                        "Ciência e Tecnologia de Alimentos",
                        "Ciências Aeronáuticas",
                        "Ciências Agrárias",
                        "Ciências Agrárias",
                        "Ciências da Natureza e suas Tecnologias",
                        "Ciências do Consumo",
                        "Ciências Humanas",
                        "Comércio Exterior",
                        "Computação",
                        "Comunicação das Artes do Corpo",
                        "Comunicação em Mídias Digitais",
                        "Comunicação Institucional",
                        "Comunicação Organizacional",
                        "Conservação e Restauro",
                        "Construção Civil",
                        "Construção Naval",
                        "Cooperativismo",
                        "Cultura",
                        "Linguagens e Tecnologias Aplicadas",
                        "Defesa e Gestão Estratégica Internacional",
                        "Design de Games",
                        "Design de Interiores",
                        "Design de Moda",
                        "Ecologia",
                        "Educomunicação",
                        "Eletrônica Industrial",
                        "Eletrotécnica Industrial",
                        "Energia e Sustentabilidade",
                        "Energias Renováveis",
                        "Engenharia Acústica",
                        "Engenharia Biomédica",
                        "Engenharia Bioquímica e de Biotecnologia",
                        "Engenharia de Biossistemas",
                        "Engenharia de Energia",
                        "Engenharia de Inovação",
                        "Engenharia de Segurança no Trabalho",
                        "Engenharia de Sistemas",
                        "Engenharia de Software",
                        "Engenharia de Transporte e da Mobilidade",
                        "Engenharia Hídrica",
                        "Engenharia Industrial Madeireira",
                        "Engenharia Mecatrônica",
                        "Escrita Criativa",
                        "Esporte",
                        "Estética e Cosmética",
                        "Estudos de Gênero e Diversidade",
                        "Estudos de Mídia",
                        "Eventos",
                        "Fabricação Mecânica",
                        "Fotografia",
                        "Gastronomia",
                        "Geofísica",
                        "Geoprocessamento",
                        "Gerontologia",
                        "Gestão Ambiental",
                        "Gestão Comercial",
                        "Gestão da Informação",
                        "Gestão da Produção Industrial",
                        "Gestão da Qualidade",
                        "Gestão da Tecnologia da Informação",
                        "Gestão de Recursos Humanos",
                        "Gestão de Segurança Privada",
                        "Gestão de Seguros",
                        "Gestão de Turismo",
                        "Gestão Desportiva e de Lazer",
                        "Gestão em Saúde",
                        "Gestão Financeira",
                        "Gestão Hospitalar",
                        "Gestão Pública",
                        "História da Arte",
                        "Hotelaria",
                        "Humanidades",
                        "Informática Biomédica",
                        "Irrigação e Drenagem",
                        "Jogos Digitais",
                        "Libras",
                        "Linguagens e Códigos e suas Tecnologias",
                        "Linguística",
                        "Logística",
                        "Luteria",
                        "Manutenção de Aeronaves",
                        "Manutenção Industrial",
                        "Marketing",
                        "Matemática e Computação e suas Tecnologias",
                        "Materiais",
                        "Mecatrônica Industrial",
                        "Mineração",
                        "Musicoterapia",
                        "Nanotecnologia",
                        "Naturologia",
                        "Negócios Imobiliários",
                        "Obstetrícia",
                        "Oceanografia",
                        "Oftálmica",
                        "Optometria",
                        "Papel e Celulose",
                        "Petróleo e Gás",
                        "Pilotagem Profissional de Aeronaves",
                        "Processos Gerenciais",
                        "Processos Metalúrgicos",
                        "Processos Químicos",
                        "Produção Audiovisual",
                        "Produção Cênica",
                        "Produção Cultural",
                        "Produção de Bebidas",
                        "Produção Editorial",
                        "Produção Fonográfica",
                        "Produção Multimídia",
                        "Produção Publicitária",
                        "Produção Sucroalcooleira",
                        "Produção Têxtil",
                        "Psicopedagogia",
                        "Quiropraxia",
                        "Radiologia",
                        "Redes de Computadores",
                        "Rochas Ornamentais",
                        "Saneamento Ambiental",
                        "Saúde",
                        "Saúde Coletiva",
                        "Secretariado",
                        "Segurança da Informação",
                        "Segurança no Trabalho",
                        "Segurança Pública",
                        "Serviços Judiciários e Notariais",
                        "Silvicultura",
                        "Sistemas Biomédicos",
                        "Sistemas de Telecomunicações",
                        "Sistemas Elétricos",
                        "Sistemas Embarcados",
                        "Sistemas para Internet",
                        "Tecnologia da Informação",
                        "Tradutor e Intérprete",
                        "Transporte",
                        "Agrimensura",
                        "Agroecologia",
                        "Agroindústria",
                        "Aquacultura",
                        "Bio",
                        "Biocombustíveis",
                        "Biotecnologia",
                        "Cafeicultura",
                        "Ciência dos Alimentos",
                        "Ciências Aeronáuticas",
                        "Ciência dos materiais",
                        "Comércio Exterior",
                        "Construção de Edifícios",
                        "Construção de Estradas",
                        "Construção Naval",
                        "Cooperativismo",
                        "Cosmetologia",
                        "Design de Jogos Digitais",
                        "Design de produto",
                        "Design gráfico",
                        "Drenagem e Irrigação",
                        "Energias Renováveis",
                        "Enologia",
                        "Esporte e Lazer",
                        "Eventos",
                        "Fotografia",
                        "Fruticultura",
                        "Gestão Comercial",
                        "Gestão da Qualidade",
                        "Gestão da Tecnologia da Informação",
                        "Gestão de Petróleo e Gás",
                        "Gestão de Recursos Hídricos",
                        "Gestão de Segurança Privada",
                        "Gestão do Agronegócio",
                        "Gestão em Serviços Jurídicos e Notariais",
                        "Gestão Financeira",
                        "Gestão Hospitalar",
                        "Gestão Portuária",
                        "Horticultura",
                        "Manutenção Industrial",
                        "Meliponicultura",
                        "Mercadologia",
                        "Mineração",
                        "Negócios Imobiliários",
                        "Oftálmica",
                        "Processamento de Dados",
                        "Processos Escolares",
                        "Processos Metalúrgicos",
                        "Produção de Aguardente[3]",
                        "Produção de Laticínios",
                        "Produção de Materiais Plásticos",
                        "Produção Fonográfica",
                        "Produção Sucroalcooeira",
                        "Produção Têxtil",
                        "Projetos de Estruturas Aeronáuticas[4]",
                        "Radiologia",
                        "Recursos Humanos",
                        "Redes de Computadores",
                        "Redes de Telecomunicações",
                        "Secretariado",
                        "Segurança da Informação",
                        "Segurança no Trabalho",
                        "Silvicultura",
                        "Sistemas de Navegação Fluvial",
                        "Sistemas Elétricos",
                        "Sistemas Embarcados",
                        "Sistemas para Internet",
                        "Telemática",
                        "Transporte Aéreo",
                        "Ciências da Informação e da Documentação",
                        "Bacharelado em Informática",
                        "Ciência da Informação",
                        "Sistemas de Informação",
                        "Engenharia de Computação",
                        "Desenvolvimento de Sistemas",
                        "Tecnologia da Informação"
                    ],
                },
                {
                    "name": "graduationEndDate",
                    "type": "date",
                    "placeholder": "ano de formação (mm/aaaa)"
                },
                {
                    "name": "preferredOffice",
                    "type": "select",
                    "placeholder": "escritório de interesse",
                    values: [
                        "São Paulo",
                        "Campinas",
                        "Ribeirão Preto",
                        "Uberlândia",
                        "Rio de Janeiro",
                        "Brasília",
                        "Recife",
                        "Salvador",
                        "Fortaleza",
                        "Belo Horizonte",
                        "Curitiba",
                        "Porto Alegre",
                        "Joinville"
                    ]
                }
            ],
        }
    ]    
}